/**
 * 提醒弹窗
 * Bai.Zhiming
 * 2019-6-28
 */

angular.module('noticeWindowModule', []).controller('noticeWindowCtrl', [
    '$scope',
    '$element',
    'noticeInfo',
    'iwoNoticeService',
    'trsHttpService',
    'messagePublishService',
    'editIsLock',
    '$state',
    '$window',
    'editingCenterAppService',
    'publicToolService',
    'editingCenterService',
    function(
        $scope,
        $element,
        noticeInfo,
        iwoNoticeService,
        trsHttpService,
        messagePublishService,
        editIsLock,
        $state,
        $window,
        editingCenterAppService,
        publicToolService,
        editingCenterService
    ) {
        initStatus();
        initData();

        //打开窗口后5秒关闭窗口
        // setTimeout(function () {
        //     noticeInfo.close();
        // },5000)
        /**
         *  消息类型说明opertype
         *       0	所有模块
         *       1	待审稿件提醒
         *       2	传稿提醒
         *       3	退稿提醒
         *       4	撤稿提醒
         *       5	取稿提醒
         *       6	个人创作稿件在渠道已签发提醒
         *       7	任务指派提醒
         *       8	任务审核提醒
         *       11	待审广告提醒
         *       12	微信群发结果提醒
         *       13	共享稿库更新提醒
         *       20	宣传通稿提醒
         *       21	上级指令-通知公告
         *       22	上级指令-撤稿
         *       23	宣传指令提醒
         *       24	应急事件提醒
         *       30	订阅源更新提醒
         *       99	选题交稿提醒
         *       120	供稿使用提醒
         *       121	站点模板发布提醒
         *       122	已收稿库更新提醒
         *       123	部门稿库更新提醒
         *       124	签发失败提醒
         *   模块信息说明modeltype
         *       1	工作协同消息
         *       2	资源更新消息
         *       3	宣传部消息
         *       4	系统消息
         */

        /**
        * [initStatus description] 初始化状态
        * @return {[type]} [description]
        */
        function initStatus() {
            $scope.status = {
                noticeInfo: noticeInfo,
                timer: '',
                closeTime: noticeInfo.hiddenTime || 600000,
            };
            $scope.draftParams = { // 消息类型基本参数
                // method: 'closemessages',
                serviceid: 'message',
                msgsocketrelids: noticeInfo.msgsocketrelid,
                isall: false,
                opertype: 1,
                socketid: noticeInfo.messageid
            };
            $scope.data = {
                editPath: editingCenterAppService.initEditPath(),
            };
            showWindow();
            dragAndDrop();
            moveSelf();
            hideWindow();
            linstenerClose();
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            iwoNoticeService.getUnReadNoticeCount();
        }

        /**
         * [stopDisplay description] 阻止浮窗消失
         * @return {[type]} [description]
         */
        $scope.stopDisplay = function () {
            clearTimeout($scope.status.timer);
            $element.stop(true, true);
            $element.fadeIn();
            $element.removeClass('window_not_focus');
            $element.addClass('window_focus');
            localStorage.setItem(
                'noticePosition',
                JSON.stringify({ messageid: noticeInfo.messageid, left: $element.css('left'), top: $element.css('top') })
            );
        };

        /**
         * [goOnDisplay description]继续消失
         * @param   {[type]}  time  [time description]
         * @return  {[type]}        [return description]
         */
        $scope.goOnDisplay = function (time) {
            var theTime = time ? time : 600000;
            if ($scope.status.timer) {
                clearTimeout($scope.status.timer);
                $scope.status.timer = null;
            }
            $scope.status.timer = setTimeout(() => {
                $element.fadeOut(3000, () => {
                    noticeInfo.close();
                });
            }, theTime);
        };

        /**
         * [closeDraftRemind description] 关闭审核人弹窗（稿件类型）
         * @return  {[type]}  [return description]
         */
        $scope.closeDraftRemind = function () {
            cancelMessage();
        };

        /**
         * [close description]关闭浮框
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.close = function (item) {
            noticeInfo.close();
            localStorage.setItem('closeNotice', noticeInfo.messageid);
            if (item && item.noticeid) {
                closeRequest(item.noticeid);
            }
            if ($scope.status.noticeInfo.opertype === 124) {
                readMessages(item);
            }
        };

        /**
         * [cancelMessage description] 取消消息
         * @return  {[type]}  [return description]
         */
        function cancelMessage() {
            noticeInfo.close();
            let params = {
                method: 'closemessages',
            };
            params = angular.extend(params, $scope.draftParams);
            trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'GET');
        }

        /**
         * [readedMessage description] 已读消息
         * @return  {[type]}  [return description]
         */
        function readedMessage() {
            let params = {
                method: 'readmessages',
            };
            params = angular.extend(params, $scope.draftParams);
            trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'GET');
        }

        /**
         * [nowSee description]立即查看
         *
         * @param   {[type]}  item  [item description]
         *
         * @return  {[type]}        [return description]
         */
        $scope.nowSee = function (item) {
            iwoNoticeService.openPreview(item, false).then(() => {
                iwoNoticeService.getUnReadNoticeCount();
            });
            $scope.close(item);
        };

        /**
         * [nowSee description]跳进详情页，调用已读接口
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.toEdit = function(item) {
            item.METADATAID = item.metadataId;
            readMessages(item);
            editIsLock.isLock(item, 1).then(function (data) {
                var editPath = $scope.data.editPath[item.docType];
                var editParams = {
                    appchannelid: item.channelId,
                    appchnldocid: item.chnldocId,
                    appmetadataid: item.metadataId,
                    appsiteid: item.siteId,
                    appplatform: 2,
                };
                var editUrl = $state.href(editPath, editParams);
                if (data.ISLOCK == 'false') {
                    $window.open(editUrl);
                } else {
                    editIsLock.checkUnlockPermissions(item, data).then(function () {
                        $window.open(editUrl);
                    });
                }
            });
            $scope.close(item);
        };

        /**
         * [readMessages description]调用已读接口
         *
         * @param   {[type]}  item  [params description]
         *
         * @return  {[type]}          [return description]
         */
        function readMessages(item) {
            publicToolService.readmessages({
                msgsocketrelids: item.msgsocketrelid,
                opertype: '124',
                modeltype: '4'
            });
        }

        /**
         * [immediateProcessing description] 进入相应编辑页
         * @param   {[type]}  data  [data description]
         * @return  {[type]}        [return description]
         */
        $scope.immediateProcessing = function (data) {
            readedMessage();
            var draftInfo = {};
            for (var key in data) { // 将对象的key值全部转为大写，因为采编是大写，而消息通知的字段是小写
                draftInfo[key.toUpperCase()] = data[key];
            }
            draftInfo.DOCTYPEID = data.docType;
            draftInfo.PLATFORM = 1; // 因为消息通知暂时无法返回platform字段，statusid字段对应不正确，目前只有送审指定审核人，所以暂时写死为1
            editingCenterService.routerToPreview(draftInfo);
            $scope.close(data);
        };

        /**
         * [linstenerClose description] 监听跨窗口关闭
         * @return {[type]} [description]
         */
        function linstenerClose() {
            let listener = window.addEventListener('storage', (e) => {
                if (e.key === 'closeNotice' && e.newValue == noticeInfo.messageid) {
                    noticeInfo.close();
                    clearTimeout($scope.status.timer);
                }
                if (e.key === 'noticePosition' && JSON.parse(e.newValue).messageid == noticeInfo.messageid) {
                    let position = JSON.parse(e.newValue);
                    $element.stop(true, true);
                    $element.fadeIn();
                    $element.removeClass('window_not_focus');
                    $element.addClass('window_focus');
                    $element.css({
                        top: position.top,
                        left: position.left,
                    });
                    if ($scope.status.timer) {
                        clearTimeout($scope.status.timer);
                        $scope.status.timer = null;
                    }
                    $scope.status.timer = setTimeout(() => {
                        $element.fadeOut(500, () => {
                            noticeInfo.close();
                        });
                    }, 600000);
                }
            });
            $scope.$on('$destroy', () => {
                window.removeEventListener('storage', listener);
            });
        }

        /**
         * [showWindow description] 显示窗口
         * @return {[type]} [description]
         */
        function showWindow() {
            $element.css({ opacity: 1 });
        }

        /**
         * [closeRequest description]关闭请求
         *
         * @param   {[type]}  id  [item description]
         *
         * @return  {[type]}        [return description]
         */
        function closeRequest(id) {
            iwoNoticeService.getCookie().then((token) => {
                const commonParams = {
                    serviceid: 'notice',
                    method: 'closeNotices',
                    noticeids: id,
                    token: token,
                };
                const params = angular.extend({}, commonParams);
                trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'GET').then((data) => {
                    if (data.issuccess === 'true' && data.data.num > 0) {
                        messagePublishService.publish('unReadNoticeCountUpdate', data.data.num);
                    }
                });
            });
        }

        /**
         * [hideWindow description] 关闭窗口
         * @return {[type]} [description]
         */
        function hideWindow() {
            $scope.status.timer = setTimeout(() => {
                $element.fadeOut(500, () => {
                    noticeInfo.close();
                });
            }, $scope.status.closeTime + 1000);
        }

        /**
         * [moveSelf description] 新窗口进入移动本窗口
         * @return {[type]} [description]
         */
        function moveSelf() {
            $scope.$on('newWindow', (event, data) => {
                if (!$element.hasClass('window_not_focus')) {
                    return;
                }
                let $brothers = $('.window_not_focus');
                let index = 0;
                for (let i = 0; i < $brothers.length; i++) {
                    let dom = $brothers[i];
                    if (dom == $element[0]) {
                        index = i;
                        break;
                    }
                }
                if ($brothers.length > data.number && index <= $brothers.length - data.number - 1) {
                    $element.fadeOut(500, () => {
                        noticeInfo.close();
                    });
                    return;
                }
                let top = ($brothers.length - index - 1) * 180 + 85;
                $element.animate(
                    {
                        top: top,
                    },
                    1000
                );
            });
        }

        /**
         * [dragAndDrop description] 支持弹窗拖拽功能
         * @return {[type]} [description]
         */
        function dragAndDrop() {
            $element.draggable({
                containment: 'body',
                handle: 'div.header',
                start(event, ui) {
                    clearTimeout($scope.status.timer);
                    $element.stop(true, true);
                    $element.fadeIn();
                    $element.removeClass('window_not_focus');
                    $element.addClass('window_focus');
                },
                stop() {
                    if ($scope.status.timer) {
                        clearTimeout($scope.status.timer);
                        $scope.status.timer = null;
                    }
                    $scope.status.timer = setTimeout(() => {
                        $element.fadeOut(500, () => {
                            noticeInfo.close();
                        });
                    }, 600000);
                    localStorage.setItem(
                        'noticePosition',
                        JSON.stringify({ messageid: noticeInfo.messageid, left: $element.css('left'), top: $element.css('top') })
                    );
                },
            });
            $scope.$on('$destroy', () => {
                clearTimeout($scope.status.timer);
            });
        }
    },
]);
